// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"feaa3047","406":"ced81c79","890":"53e8b518"}[chunkId] + ".chunk.js";
};